export default {
  // FrontPage.vue
  frontPageRequirementTitle: 'Mio',
  frontPageProvideTitle: 'Offro',
  frontPagePersonalCenterTitle: 'Profilo',
  login: 'Accedi',
  home_chatWithOctopie: 'Comprendo i tuoi pensieri',
  home_chatNeedUnderstood: 'I tuoi pensieri sono stati capiti',
  home_draftBannerTitle: 'Completa il tuo messaggio',
  home_draftBannerSubtitle: 'L\'IA ha già preparato il tuo messaggio — tocca per continuare',
  home_tabHome: 'Home',

  // App.vue
  appRequirementTitle: 'Diamo valore a ogni suggerimento e feedback',
  appRequirementBtn: 'Invia',
  appSubmitSuccess: 'Inviato con successo, grazie per il tuo feedback',
  appFeedbackLink: 'Feedback/Suggerimenti',
  mobile_banner_text: 'Per la migliore esperienza, usa la nostra app',
  mobile_banner_btn: 'Ottieni l\'app',

  // Common
  loading: 'Caricamento...',
  confirm: 'Conferma',
  cancel: 'Annulla',
  save: 'Salva',
  delete: 'Elimina',
  edit: 'Modifica',
  add: 'Aggiungi',
  search: 'Cerca',
  refresh: 'Aggiorna',
  change_batch: 'Rimescola',
  back: 'Indietro',
  submit: 'Invia',
  close: 'Chiudi',
  ok: 'OK',
  yes: 'Sì',
  no: 'No',
  send: 'Invia',
  block: 'Blocca',
  more: 'Altro',
  logout: 'Disconnetti',
  settings: 'Impostazioni',
  view_guide: 'Vedi guida',
  feedback: 'Feedback',
  feedback_title: 'Feedback',
  feedback_new: 'Nuovo feedback',
  feedback_empty: 'Ancora nessun feedback',
  feedback_hint: 'Dicci cosa ne pensi...',
  feedback_submit: 'Invia',
  feedback_submit_success: 'Feedback inviato con successo',
  feedback_submit_failed: 'Invio del feedback non riuscito',
  feedback_reply_label: 'Risposta della piattaforma',
  register: 'Registrati',
  name: 'Nome',
  email: 'Email',
  mobile: 'Cellulare',
  password: 'Password',
  verification_code: 'Codice di verifica',
  company_name: 'Beijing Liangshao Technology Co., Ltd.',
  all_rights_reserved: 'Tutti i diritti riservati.',
  footerVersion: 'Versione {version}',
  copy: 'Copia',
  regenerate: 'Rigenera',
  generate: 'Genera',
  contact_now: 'Chatta',
  yours: 'tu',
  xiaoyao_analysis: 'Analisi IA',
  brand_name: 'OctoSay',
  anonymous: 'Anonimo',
  no_summary: 'Nessun riassunto',
  file: 'File',
  discover: 'Scopri',
  discover_title: 'Scopri',
  discover_hotChannels: 'Canali popolari',
  discover_allChannels: 'Tutti',
  discover_searchChannel: 'Cerca canale',
  discover_noChannels: 'Nessun canale trovato',

  // Messages
  operationSuccess: 'Operazione riuscita',
  operationFailed: 'Operazione non riuscita',
  networkError: 'Errore di rete, riprova più tardi',
  dataLoadingFailed: 'Caricamento dei dati non riuscito',
  noData: 'Nessun dato',
  deleteConfirm: 'Sicuro di voler eliminare?',
  saveConfirm: 'Sicuro di voler salvare?',

  // Form Validation
  required: 'Questo campo è obbligatorio',
  emailInvalid: 'Inserisci un indirizzo email valido',
  phoneInvalid: 'Inserisci un numero di telefono valido',
  passwordTooShort: 'La password deve avere almeno {min} caratteri',
  passwordMismatch: 'Le password non corrispondono',

  // Time
  today: 'Oggi',
  yesterday: 'Ieri',
  justNow: 'Adesso',
  minutesAgo: '{min} minuti fa',
  hoursAgo: '{hour} ore fa',
  daysAgo: '{day} giorni fa',

  // Footer
  about: 'Informazioni',
  footerPrivacy: 'Informativa sulla privacy',
  footerTerms: 'Termini di servizio',
  footerSupport: 'Assistenza',

  // Register
  registerAgeConfirm: 'Confermo di avere almeno 13 anni',
  registerAgeConfirm18: 'Confermo di avere almeno 18 anni',
  registerTermsPrefix: 'Ho letto e accetto i ',
  registerTermsAnd: ' e ',
  registerAgeError: 'Conferma la tua età',
  registerTermsError: 'Accetta i termini e l\'informativa sulla privacy',

  // Chat
  chatPrivacyTip: 'Scrivi il tuo messaggio nell\'gruppo e l\'IA prima chiacchiererà con te per chiarire. Quando confermi, il tuo messaggio e il riassunto dell\'IA vengono pubblicati insieme e AI continua a cercare match.',
  aiChat_quickSuggestions: 'Prova a dire',
  aiChat_welcome: "Ciao! Dimmi cosa cerchi.",

  // Chat - AI Progress Steps (new)
  aiChat_readyToPost: 'Dettagli capiti — pubblica per trovare il tuo match',
  aiChat_readyToPostHint: 'Continua a chiacchierare per aggiungere dettagli o aggiornare il riassunto quando vuoi',
  aiChat_progressStep1: 'Capisci i dettagli',
  aiChat_progressStep1Done: 'Dettagli capiti',
  aiChat_progressStep2: 'Riassunto IA',
  aiChat_progressStep2Desc: 'AI crea un riassunto per l\'abbinamento',
  aiChat_progressStep3: 'Pubblica nell\'Gruppo',
  aiChat_progressStep3Desc: 'Pubblica e trova il tuo match',
  aiChat_publishExtraHint: 'Inserisci il tuo messaggio per l\'gruppo',
  aiChat_publishMsgRequired: 'Obbligatorio',
  aiChat_publishMsgLabel: 'Il tuo messaggio per l\'gruppo',
  aiChat_matchSummaryLabel: 'Riassunto IA',

  ai_generated_label: 'AI Generated',

  ai_content_disclaimer: 'Il seguente contenuto è generato da IA e solo a titolo di riferimento.',
  aiChat_publishSuggestionHint: 'Toca per sostituire',
  aiChat_allowDirectContact: 'Consenti contatto diretto',
  aiChat_allowDirectContactDesc: 'Gli altri possono contattarti direttamente senza fare match',
  channel_chat_session_publishToChannel: 'Pubblica nell\'Gruppo Octo',
  aiChat_newChat: 'Reimposta',

  // Channels / Gruppi
  home_tabChannels: 'Gruppi Octo',
  channels_title: 'Gruppi Octo',
  channels_myChannels: 'Gruppo a cui appartieni',
  channels_discover: 'Scopri',
  channels_noChannels: 'Ancora nessun gruppo',
  channels_noMyGroupsTitle: 'Non ti sei ancora unito a nessun gruppo',
  channels_noMyGroupsSubtitle: 'Cerca un gruppo a cui unirti e inizia a connetterti',
  channels_searchGroupsBtn: 'Cerca gruppo',
  channels_loginPrompt: 'Accedi per vedere gli gruppo',
  channels_create: 'Crea Gruppo Octo',
  channels_search: 'Cerca Gruppo Octo',
  channels_searchMyGroups: 'Cerca i miei Gruppo Octo',
  channels_searchHint: 'Cerca',
  channels_searchHintChats: 'Cerca chat...',
  channels_searchHintGroups: 'Cerca gruppo...',
  channels_searchHintMy: 'Cerca gruppo a cui appartieni...',
  channels_joinByCode: 'Unisciti con codice',
  channels_joinByCodeTitle: 'Unisciti all\'Gruppo Octo con codice',
  channels_joinByCodeHint: 'Inserisci il codice Gruppo Octo',
  channels_joinByCodeConfirm: 'Unisciti',
  channels_joinByCodeNotFound: 'Gruppo non trovato',
  channels_createNewGroup: 'Crea un nuovo Gruppo Octo',
  channels_noResults: 'Nessun gruppo trovato',
  channel_detail_join: 'Unisciti',
  channel_detail_leave: 'Esci',
  channel_detail_members: 'membri',
  // 聚合进群消息 banner（joinMsgs）
  channelJoinMsg_oneJoined: '{name} è entrato nel hub',
  channelJoinMsg_twoJoined: '{name1} e {name2} sono entrati nel hub',
  channelJoinMsg_multiJoined: '{name1}, {name2} e altri {n} sono entrati nel hub',
  channelJoinMsg_oneAndMoreJoined: '{name} e altri {n} sono entrati nel hub',
  channelJoinMsg_membersJoined: '{n} membri sono entrati nel hub',

  // Feed
  channels_feed: 'Chat',
  channels_groups: 'Gruppo',
  feed_related: 'Correlati',
  feed_recommend: 'Consigliati',
  feed_empty: 'Ancora nessun feed, esplora gli gruppo popolari',
  feed_goToGroup: 'Vedi nell\'gruppo',
  feed_joinGroupAndSendMsg: 'Unisciti a un gruppo e invia un messaggio',
  channel_detail_channelCode: 'Codice Gruppo Octo',
  channel_detail_invitePhrase: 'Invito a unirsi a "{name}"\nCodice di invito {code} — apri l\'app per entrare automaticamente · L\'IA chiarisce prima e trova le persone giuste',
  channel_detail_post: 'Pubblica nell\'Gruppo',
  channel_detail_aiHint: "Scrivi il tuo messaggio nell'gruppo e AI chiarirà prima i dettagli",
  channel_input_hint: 'Di\' qualcosa...',
  channel_leave_confirm_message: 'Sicuro di voler uscire da questo gruppo? Non riceverai più messaggi dall\'gruppo.',
  channel_invite_notFound: 'Gruppo non trovato o link scaduto',
  channel_invite_joinBtn: 'Scarica l\'app OctoSay',
  channel_invite_hint: 'Scarica l\'app, poi scansiona questo codice QR o cerca il nome dell\'gruppo per unirti',
  channel_invite_globalHintTitle: 'Stai per scaricare la versione Globale',
  channel_invite_globalHintIOS: 'Questa app potrebbe non essere disponibile nell\'App Store cinese. Passa a un Apple Store al di fuori della Cina e cerca OctoSay, oppure scarica l\'APK direttamente qui sotto.',
  channel_invite_globalHintAndroid: 'Google Play potrebbe non essere accessibile nella tua regione. Ti consigliamo di scaricare l\'APK direttamente, oppure prova Google Play.',
  channel_invite_globalHintDefault: 'L\'app potrebbe non essere disponibile nello store locale. Ti consigliamo di scaricare l\'APK direttamente, oppure prova l\'App Store.',
  channel_invite_globalBtnAppStore: 'Vai all\'App Store',
  channel_invite_globalBtnGooglePlay: 'Vai a Google Play',
  channel_invite_globalBtnAPK: 'Scarica APK direttamente',
  channel_invite_defaultDesc: 'Unisciti a {name} su OctoSay',
  share: 'Condividi',
  share_channel: 'Condividi gruppo',
  share_channel_link: 'Condividi link',
  channel_detail_inviteCode: 'Codice invito',
  channel_detail_copyLink: 'Copia link',
  share_session_title: 'Un post su OctoSay',
  share_match_title: 'Un match su OctoSay',
  share_session_text: '{userName}: {summary}',
  share_session_text_no_summary: 'Guarda cosa ha pubblicato {userName} su OctoSay',
  session_share_notFound: 'Post non trovato o link scaduto',
  session_share_fromChannel: 'Da Gruppo Octo',
  session_share_downloadBtn: 'Scarica l\'app OctoSay',
  session_share_hint: 'Scarica l\'app per vedere il post completo e unirti all\'gruppo',
  session_share_openInApp: 'Apri nell\'app',
  toast_link_copied: 'Link copiato',
  toast_no_share_data: 'Niente da condividere',
  channels_joinByQR: 'Codice QR',
  channels_joinByQRWebHint: 'Il web non supporta la scansione QR. Inserisci il codice dell\'gruppo per unirti.',
  channels_joinByQRTitle: 'Unisciti con codice QR',
  channel_detail_qrCode: 'Codice QR',
  channel_detail_qrCodeSave: 'Salva immagine',
  channel_detail_qrCodeSaveHint: 'Fai clic destro sull\'immagine per salvarla',
  channel_detail_qrCodeSaved: 'Salvato nell\'album',
  channel_detail_qrCodeSaveFailed: 'Salvataggio non riuscito, riprova',
  channel_detail_locateFailed: 'Localizzazione del messaggio non riuscita',
  channel_detail_locateError: 'Errore nella localizzazione del messaggio',
  channel_detail_myMessages: 'I miei messaggi',
  channel_detail_searchMessages: 'Cerca messaggi',
  channel_detail_aiChat: 'Chat di AI',
  channel_detail_matchHistory: 'Cronologia dei match',
  channel_create_title: 'Crea Gruppo Octo',
  channel_create_name: 'Nome dell\'Gruppo Octo',
  channel_create_description: 'Descrizione',
  channel_create_submit: 'Crea',
  channelCreate_aiAssist: 'AI ti aiuterà a creare un gruppo adatto',
  channelCreate_nameHint: 'Inserisci un nome per il tuo gruppo',
  channelCreate_descHint: 'Descrivi di cosa tratta il tuo gruppo',
  channelCreate_creating: 'Creazione...',
  channelCreate_created: 'Gruppo creato!',
  channelCreate_failed: 'Creazione dell\'gruppo non riuscita',
  channelCreate_welcomeMsg: "Ciao! Sono qui per aiutarti a creare un gruppo. Dimmi che tipo di gruppo vorresti — il nome, l'argomento o lo scopo — e ti aiuterò a trasformarlo in nome e introduzione del gruppo, generando anche l'avatar.",
  channelCreate_aiHint: 'Scrivi l\'argomento del tuo gruppo...',
  channelCreate_clarifyingProgress: 'Organizzazione dell\'argomento del tuo gruppo...',
  channelCreate_readyToCreate: 'Pronto a creare l\'Gruppo Octo',
  channelCreate_step1: 'Descrivi l\'argomento',
  channelCreate_step1Done: 'Idea chiarita',
  channelCreate_step2: 'Crea Gruppo Octo',
  channelCreate_confirmBtn: 'Conferma creazione',
  channelCreate_publicNotice: 'Gli gruppo sono spazi pubblici dove persone con interessi in comune si riuniscono e si connettono. La piattaforma può gestire, aggiornare o unire gli gruppo quando necessario. Condividi questo gruppo con chi potrebbe essere interessato.',
  channelCreate_similarGroupsTitle: 'Gruppo Octo simili trovati',
  channelCreate_similarGroupsDesc: 'Questi gruppo potrebbero corrispondere a ciò che vuoi',
  channelCreate_exactMatchHint: 'Esiste già un gruppo con questo nome esatto!',
  channelCreate_joinHint: 'Questi gruppo esistenti potrebbero fare al caso tuo',
  channelCreate_joinExisting: 'Unisciti a un Gruppo Octo esistente',
  channelCreate_stillCreate: 'Crea comunque un nuovo Gruppo Octo',
  channel_chat_session_comments: 'Commenti',
  channel_chat_session_commentHint: 'Scrivi un commento...',
  channel_chat_session_sendComment: 'Commento',
  channel_chat_session_loadMore: 'Carica altro',
  channel_chat_session_noComments: 'Ancora nessun commento',
  channel_chat_session_deleteComment: 'Elimina',
  channelSearch_title: 'Cerca nell\'Gruppo',
  channelSearch_placeholder: 'Cerca messaggi...',
  channelSearch_onlyMine: 'Solo i miei post',
  channelSearch_tabAllMessages: 'Messaggi dell\'gruppo',
  channelSearch_tabMyMessages: 'I miei messaggi',
  chatMsgSearch_placeholder: 'Cerca messaggi',
  chatMsgSearch_tabMsgs: 'Messaggi',
  chatMsgSearch_tabContacts: 'Contatti',
  chatMsgSearch_emptyPrompt: 'Digita parole chiave per cercare messaggi',
  chatMsgSearch_tooShort: 'Digita almeno 2 caratteri per cercare',
  chatMsgSearch_contactEmptyPrompt: 'Digita un nome utente o un\'email per cercare contatti',
  chatMsgSearch_noContacts: 'Nessun contatto corrispondente',
  chatMsgSearch_inChatPlaceholder: 'Cerca in questa chat',
  channelHistory_title: 'Cronologia',
  channelHistory_myMessages: 'I miei messaggi',
  channelHistory_loadMore: 'Carica altro',
  channel_settings_push: 'Notifiche Gruppo Octo',
  channel_settings_commentPush: 'Notifiche commenti',
  channel_settings_likePush: 'Notifiche di like',
  channel_settings_receiveNotifications: 'Ricevi notifiche',
  channel_settings_directContact: 'Consenti contatto diretto',
  session_published: 'Pubblicato',
  session_publishFailed: 'Pubblicazione non riuscita',
  session_setDirectContactSuccess: 'Impostazione salvata',
  session_setDirectContactFailed: 'Salvataggio dell\'impostazione non riuscito',
  session_setPrivate: 'Rendi privato',
  session_setPublic: 'Rendi pubblico',
  session_pauseMatching: 'Metti in pausa il match',
  session_resumeMatching: 'Riprendi il match',
  session_matchPausedToast: 'Match in pausa',
  session_matchResumedToast: 'Match ripreso',
  match_matchingPausedTitle: 'Il match è in pausa',
  match_reasonTag: 'Motivo del match',
  match_matchingPausedHint: 'Riattiva il match quando vuoi.',
  session_confirmSetPrivate: 'Rendere privato questo contenuto? Gli altri utenti non potranno vederlo.',
  session_messageIsPrivate: 'Questo messaggio è privato',
  chatSessionComment_replyHint: 'Scrivi un commento...',
  chatSessionComment_reply: 'Commento',
  chatSessionComment_count: '{n} commento | {n} commenti',
  chatSessionMatch_count: '{n} match',
  chatSessionComment_replyTo: 'Rispondi',
  chatSessionComment_inputHint: 'Scrivi un commento...',
  chatSessionComment_send: 'Invia',
  chatSessionComment_delete: 'Elimina',
  chatSessionComment_deleteConfirm: 'Sicuro di voler eliminare questo commento?',
  chatSessionComment_loadMore: 'Carica altro',
  chatSessionComment_noMore: 'Non ci sono altri commenti',
  chatSessionComment_loginToComment: 'Accedi per commentare',
  chatSessionComment_viewEarlier: 'Vedi le {n} risposte precedenti',
  chatSessionLike_like: 'Mi piace',
  chatSessionLike_liked: 'Ti piace',
  chatSessionLike_count: 'mi piace',
  chatSessionBookmark_bookmark: 'Salva',
  chatSessionBookmark_bookmarked: 'Salvato',
  chatSessionMatch_viewMatches: 'Vedi match',
  chatSessionMatch_matchHistory: 'Cronologia dei match',
  chatSessionMatch_noMatches: 'Ancora nessun match',
  channel_match_achievement: '{count} post abbinati con successo',
  channel_match_achievement_view: 'Vedi →',
  channel_matchHistory_title: 'Cronologia match del canale',
  chatSessionMatch_matchedAt: 'Match fatto alle {time}',
  discover_userMsgLabel: 'L\'utente ha detto',
  common_loading: 'Caricamento...',
  common_sending: 'Invio...',
  common_error: 'Errore',
  common_success: 'Successo',
  common_me: 'Io',

  // Chat - Set Public / Pick Location
  aiChat_clarifyingProgress: "L'IA sta chiarendo la tua esigenza perché ogni messaggio pubblicato funzioni; dopo la pubblicazione continuerà a trovarti match",
  aiChat_clarifyingAlmostDone: 'Ci siamo quasi, conferma per favore',
  aiChat_clarifyingOneMore: 'Manca all\'incirca 1 domanda, poi puoi pubblicare',
  aiChat_clarifyingRemaining: 'Mancano all\'incirca {count} round, quasi fatto',
  aiChat_clarifyingEvaluating: 'Valutazione dei progressi...',
  aiChat_setPublicMatch: 'Rendi pubblico e abbina',
  aiChat_needsClarifiedPublic: "Ti ho capito. Quando confermi e pubblichi, AI continuerà ad abbinarti.\nAggiungi altri dettagli quando vuoi.",
  aiChat_needsClarifiedPrivate: 'Capito! Rendi pubblico e lasciami continuare a cercare match!\nDimmi altri dettagli quando vuoi.',
  aiChat_setPublicTitle: 'Rendi pubblico',
  aiChat_setPublicMessage: 'Il tuo contenuto sarà visibile agli altri così OctoSay può trovare match complementari.\n\nInformazioni che verranno condivise:\n• Il tuo nome utente e avatar\n• Il riassunto del tuo contenuto\n• Il contenuto della conversazione (visibile in Scopri)\n\nPuoi riportarlo a privato in qualsiasi momento.',
  aiChat_findMatches: 'Vedi risultato del match',
  aiChat_publishing: 'Pubblicazione...',
  aiChat_matchSectionTitle: 'Il tuo messaggio sta meglio in questi gruppi — tocca per pubblicare',
  aiChat_joinedBadge: 'Membro',
  aiChat_matchSectionEmpty: 'Nessun gruppo con buona corrispondenza — puoi creare un nuovo gruppo e pubblicare lì',
  aiChat_suggestPublishCreateNew: 'Crea un nuovo gruppo',
  aiChat_repickChannel: 'Cambia gruppo',
  aiChat_creatingChannelTitle: 'Nessun gruppo adatto — ne stiamo creando uno per te',
  aiChat_creatingChannelHint: 'L’IA sta creando un gruppo per la tua richiesta, poi passi subito alla pubblicazione — di solito 10-30 secondi',
  aiChat_publishToChannelHint: 'Verrà pubblicato in "{name}"',
  aiChat_pickChannelTitle: 'Scegli un gruppo in cui pubblicare',
  aiChat_matchingChannelTitle: 'Sto cercando il gruppo giusto per te',
  aiChat_matchingChannelHint: 'Ricerca in base alla tua richiesta — di solito da pochi secondi a mezzo minuto',
  aiChat_matchUnavailableTitle: 'Consigli non disponibili',
  aiChat_matchUnavailableHint: 'Cerca un gruppo qui sotto oppure chiudi e riapri la pubblicazione',
  aiChat_waitSlowHint: 'Sta impiegando più tempo del solito, ma è ancora in corso — attendi ancora un poco o cerca un gruppo qui sotto',
  aiChat_creatingSlowHint: 'La creazione sta impiegando più tempo del solito, ma è ancora in corso — poi passi subito alla pubblicazione',
  aiChat_pickChannelEmptyHint: 'Nessun gruppo correlato trovato. Crea un nuovo gruppo e pubblica il tuo messaggio',
  aiChat_loadMore: 'Carica altro',
  sidebar_publish: 'Pubblica',
  chat_selectLocationOnMap: 'Seleziona una posizione sulla mappa',

  // App.vue new
  placeholder_email: 'Inserisci l\'email',
  placeholder_mobile: 'Inserisci il numero di cellulare',
  placeholder_password: 'Inserisci la password',
  placeholder_name: 'Inserisci il tuo nome',
  random_nickname: 'Casuale',
  placeholder_verification_code: 'Inserisci il codice di verifica',
  sending: 'Invio...',
  registering: 'Registrazione...',
  send_code: 'Invia codice',
  retry_in_seconds: 'Riprova tra {countdown}s',
  toast_enter_email: 'Inserisci l\'email',
  toast_enter_mobile: 'Inserisci il numero di cellulare',
  toast_invalid_email: 'Inserisci un formato email valido',
  toast_invalid_mobile: 'Inserisci un numero di cellulare valido',
  toast_send_code_failed: 'Invio del codice di verifica non riuscito',
  toast_code_sent: 'Codice di verifica inviato all\'email',
  toast_code_sent_sms: 'Codice di verifica inviato al cellulare',
  toast_send_code_error: 'Invio del codice di verifica non riuscito, riprova più tardi',
  toast_fill_all_fields: 'Compila tutti i campi',
  toast_login_failed: 'Accesso non riuscito',
  toast_login_success: 'Accesso effettuato',
  oauthOr: 'oppure',
  toast_oauth_login_failed: 'Accesso con Google non riuscito',
  toast_oauth_login_error: 'Errore di accesso con Google, riprova',
  toast_login_error: 'Accesso non riuscito, riprova più tardi',
  toast_register_failed: 'Registrazione non riuscita',
  toast_register_success: 'Registrazione riuscita',
  toast_register_error: 'Registrazione non riuscita, riprova più tardi',

  // AdBanner.vue
  ad: 'Annuncio',

  // ContactAdGate.vue 联系前广告闸门
  contactAd_gateTitle: 'Prima di connetterti',
  contactAd_gateSubtitle: 'Questa breve pausa mantiene OctoSay gratuito — grazie per il tuo supporto!',
  contactAd_waitBtn: 'Continua tra {sec}s',
  contactAd_continueBtn: 'Vai alla chat',

  // ChannelDetail.vue 私聊按钮
  session_privateChat: 'Chat',

  // AiMatch.vue
  ai_welcome_msg: 'Ciao, sono AI. Dimmi cosa hai in mente — un compagno, un partner, uno scambio di competenze o QUALSIASI cosa.',
  default_username: 'Utente',

  // AvatarCropDialog.vue
  crop_hint: 'Pizzica per lo zoom, trascina per regolare',
  toast_crop_failed: 'Ritaglio dell\'immagine non riuscito',

  // ChatBox.vue
  loading_match_info: 'Caricamento info match...',
  view_match_details: 'Vedi dettagli del match',
  step_clarify_needs: 'Chiarisci',
  step_ai_matching: 'Pubblica nell\'Gruppo',
  step_connect: 'Match IA',
  make_private: 'Rendi privato',
  setting: 'Impostazione...',
  action_photo: 'Foto',
  action_file: 'File',
  action_video: 'Video',
  action_location: 'Posizione',
  hint_get_app: 'Ottieni l\'app per restare connesso',
  match_finding_title: 'I tuoi match',
  match_finding_subtitle: 'AI continua ad abbinarti',
  match_time_hint: 'Questo processo di solito richiede 1-2 minuti',
  match_result_stats: 'Trovati {matched} match migliori{interested}',
  match_tap_to_connect: 'Toca per iniziare la conversazione',
  match_channel_hint: 'Abbinamento nell\'gruppo <strong>#{channel}</strong>. Priorità ai match dello stesso gruppo, ma possono includere altri gruppo quando necessario.',
  label_perfect_match: 'Match migliore',
  label_worth_a_look: 'Da vedere',
  match_no_result_title: 'Sto ancora cercando un match per te',
  match_no_result_desc: 'Condividi altri dettagli per aiutare OctoSay a trovare i match giusti. Installa l\'app per ricevere notifiche quando qualcuno fa match con te.',
  go_back: 'Indietro',
  no_public_requirements: 'Ancora nessun post pubblico',
  channelEmpty_title: 'Qui è tutto tranquillo',
  channelEmpty_subtitle: 'Sii il primo a condividere i tuoi pensieri',
  channelEmpty_hint: "Scrivi le tue idee e AI ti aiuterà a chiarirle e continuare ad abbinarti, così il tuo messaggio non si perde",
  channelEmpty_action: 'Condividi i tuoi pensieri',
  stay_connected: 'Rimani connesso',
  download_app_desc: 'Ottieni l\'app per chattare e ricevere notifiche all\'istante quando qualcuno ti connette!',
  app_store: 'App Store',
  google_play: 'Google Play',
  direct_apk: 'APK diretto',
  match_history: 'Cronologia dei match',
  no_match_history: 'Ancora nessuna cronologia di match',
  finding_matches: 'AI continua a cercare match per te - Dopo aver pubblicato un messaggio in un gruppo',
  discover_connect_hint: 'Potrai chattare con loro quando c\'è un match!',
  match_initializing: 'Inizializzazione...',
  placeholder_login_to_chat: 'accedi per dirmi cosa hai in mente',
  toast_need_clear: 'La tua idea è chiara!',
  toast_ai_responding: 'AI sta rispondendo, attendi...',
  toast_uploading_image: 'Caricamento immagine, attendi...',
  toast_uploading_file: 'Caricamento file, attendi...',
  toast_max_photos: 'Massimo {max} foto consentite',
  toast_uploading: 'Caricamento, attendi...',
  toast_file_too_large: '{name} supera il limite di 5MB',
  toast_video_too_large: '{name} supera il limite di 20MB',
  toast_video_processing: 'Il video è in elaborazione, attendi...',
  toast_upload_link_failed: 'Errore nel link di caricamento',
  analyzing_image: 'Analisi dell\'immagine...',
  toast_location_confirmed: 'Posizione confermata',
  toast_location_selected: 'Posizione selezionata',
  toast_enter_search: 'Inserisci il contenuto da cercare',
  toast_search_failed: 'Ricerca non riuscita',
  toast_no_locations: 'Nessuna posizione trovata',
  toast_search_error: 'Ricerca non riuscita, riprova',
  toast_located_at: 'Trovato a: {address}',
  toast_shared_finding: 'Condiviso! Ricerca dei match...',
  toast_update_failed: 'Aggiornamento non riuscito',
  toast_set_private: 'Impostato come privato',
  toast_no_matches: 'Nessun match trovato',
  toast_matches_found: 'Trovati {count} match migliori',
  toast_start_conversation_first: 'Prima inizia una conversazione',
  toast_load_history_failed: 'Caricamento della cronologia dei match non riuscito',
  toast_ai_timeout: 'AI ha impiegato troppo, riprova',
  toast_message_blocked: 'Messaggio bloccato',
  network_disconnected: 'Rete disconnessa',
  toast_publish_success: 'Pubblicato nell\'gruppo!',
  toast_publish_failed: 'Pubblicazione nell\'gruppo non riuscita',

  // ChatMsgList.vue
  collapse_thinking: 'comprimi il pensiero',
  expand_thinking: 'espandi il pensiero',
  thinking: 'sta pensando',
  select_date: 'Seleziona data',
  selected_location: 'Posizione selezionata',
  msg_blocked: 'Bloccato',
  retry: 'Riprova',
  msg_read: 'Letto',
  msg_sent: 'Inviato',
  msg_unread: 'Non letto',
  label_start_datetime: 'Data e ora di inizio:',
  label_end_datetime: 'Data e ora di fine:',
  toast_select_start_datetime: 'Seleziona data e ora di inizio',
  toast_end_before_start: 'La data/ora di fine non può precedere quella di inizio',
  report_message: 'Segnala messaggio',
  block_user: 'Blocca utente',
  msg_revoke: 'Ritira',
  msg_quote: 'Cita',
  msg_revoked_self: 'Hai ritirato un messaggio',
  msg_revoked_other: 'L\'altra parte ha ritirato un messaggio',
  // Neutral text inside quote block: the revoker is the sender of the quoted message, unrelated to current message direction
  msg_revoked_generic: 'Messaggio ritirato',
  // Platform removal (content moderation manual review), distinct from self-revoke
  msg_revoked_platform: 'Questo messaggio è stato ritirato dalla piattaforma per violazione delle regole',
  msg_blocked_label: 'This message was blocked by the platform',
  toast_revoke_success: 'Messaggio ritirato',
  toast_revoke_failed: 'Ritiro del messaggio non riuscito',
  toast_load_data_failed: 'Caricamento dei dati non riuscito, aggiorna.',
  toast_file_url_missing: 'URL del file non trovato',
  toast_block_success: 'Utente bloccato con successo',
  toast_block_failed: 'Blocco dell\'utente non riuscito',

  // ChatSession.vue
  no_more_records: 'non ci sono altri record.',
  title_needs_clarified: 'Pensieri chiariti',
  title_clarifying: 'Chiarisco i tuoi pensieri',
  title_public: 'Pubblico',
  title_private: 'Privato',
  badge_clarified: 'Chiarito',
  badge_clarifying: 'In chiarificazione',
  badge_only_me: 'Solo io',
  badge_expired: 'Scaduto',
  title_expired: 'Scaduto',
  no_chat_history: 'Nessuna cronologia chat',

  // ContactMethods.vue
  block_status_banner: 'Hai bloccato questo utente',
  unblock_user: 'Sblocca utente',
  toast_block_missing_id: 'Impossibile bloccare: manca l\'ID utente',
  dialog_block_confirm: 'Sicuro di voler bloccare {name}? Non riceverai alcun messaggio da questa persona.',
  toast_user_blocked: '{name} è stato bloccato',
  toast_unblock_missing_id: 'Impossibile sbloccare: manca l\'ID utente',
  toast_user_unblocked: '{name} è stato sbloccato',

  // BlockedUsers.vue
  blocked_users: 'Utenti bloccati',
  blocked_users_empty: 'Nessun utente bloccato',
  blocked_users_empty_hint: 'Gli utenti bloccati non potranno più inviarti messaggi',
  blocked_users_unblock: 'Sblocca',
  dialog_unblock_confirm: 'Dopo lo sblocco, potrà inviarti di nuovo messaggi.',
  toast_unblock_success: 'Sbloccato',
  toast_unblock_failed: 'Sblocco non riuscito, riprova',
  blocked_users_load_failed: 'Caricamento non riuscito. Toca per riprovare',
  blocked_users_blocked_at: 'Bloccato il {date}',
  blocked_users_unknown_user: 'Utente sconosciuto',

  // Contacts.vue
  no_connections: 'Ancora nessun messaggio',
  chat_with: 'Chatta con {name}',
  toast_load_contacts_failed: 'Caricamento delle connessioni non riuscito: {msg}',
  toast_load_contacts_error: 'Caricamento delle connessioni non riuscito. Aggiorna e riprova.',
  time_just_now: 'Adesso',
  time_minutes_ago: '{min}m fa',
  time_hours_ago: '{hour}h fa',
  time_days_ago: '{day}g fa',

  // InteractionNotification.vue
  interaction_notification_title: 'Notifiche',
  interaction_notification_subtitle: 'Commenti e mi piace',
  interaction_notification_empty: 'Ancora nessuna notifica',
  interaction_notification_comment: 'ha commentato: {content}',
  interaction_notification_like: 'gli/le è piaciuto il tuo post',
  interaction_notification_reply: 'ha risposto: {content}',
  interaction_notification_bookmark: 'ha salvato il tuo post',
  toast_load_notifications_failed: 'Caricamento delle notifiche non riuscito: {msg}',
  toast_load_notifications_error: 'Caricamento delle notifiche non riuscito. Aggiorna e riprova.',
  mark_all_read: 'Segna tutti come letti',
  toast_mark_all_read_failed: 'Operazione non riuscita, riprova',
  contacts_dnd: 'Silenzia notifiche',
  dnd_enabled: 'Notifiche silenziate',
  dnd_disabled: 'Notifiche riattivate',
  dnd_action_enable: 'Silenzia notifiche',
  dnd_action_disable: 'Riattiva notifiche',

  // Discover.vue
  toast_load_sessions_failed: 'Caricamento delle sessioni non riuscito: {msg}',
  toast_load_sessions_error: 'Caricamento delle sessioni non riuscito',
  discover_noMessages: 'Ancora nessun messaggio',

  // EmojiInputArea.vue
  placeholder_default: 'Condividi altri dettagli con AI',
  userChat_typeMessage: 'Scrivi un messaggio...',
  select_emoji: 'Seleziona emoji',
  badge_new: 'nuovo',
  channel_search_placeholder: 'Inserisci il canale',
  channel_picker_empty: 'Inserisci il canale',

  // FrontPage.vue
  tab_chat_with_ai: 'Fai capire a OctoSay chi sei',
  history_chats: 'Cronologia',
  tab_connections: 'Match',
  tab_conversations: 'Messaggi',
  tab_profile: 'Profilo',
  new_session: 'Nuovo',
  history_tab_chats: 'Miei',
  history_tab_matches: 'Match',
  channels_octosay: 'Gruppi Octo',
  tab_matches: 'Match',
  tab_messages: 'Messaggi',

  // Header.vue
  slogan: 'OctoSay - L\'IA che ti capisce e ti abbina alla persona giusta',
  app_name: 'OctoSay',
  slogan_short: 'L\'IA che ti capisce e ti abbina alla persona giusta',
  slogan_ai: 'L\'IA che ti capisce e ti abbina alla persona giusta',
  get_the_app: 'Ottieni l\'app',
  desc_iphone_ipad: 'iPhone / iPad',
  desc_android: 'Android',
  search_in_app_stores: 'oppure cerca OctoSay negli store',

  // MapLocationPicker.vue
  placeholder_search_location: 'Cerca posizione...',
  coords_display: 'Longitudine: {lng}, Latitudine: {lat}',
  toast_no_geolocation: 'Il tuo browser non supporta la geolocalizzazione',
  toast_location_permission_denied: 'Impossibile ottenere la tua posizione, controlla i permessi di localizzazione',
  loading_address: 'Caricamento indirizzo...',

  // MatchedSession.vue
  created_at: 'Creato: {time}',
  ai_match_analysis: 'Analisi del match di AI',
  error_missing_session_params: 'Mancano i parametri di sessione richiesti',
  match_private_hint: 'Questa sessione è privata. Il contenuto non è disponibile',

  // PersonalCenter.vue
  label_name: 'Nome:',
  placeholder_enter_name: 'Inserisci il tuo nome',
  label_bio: 'Bio:',
  placeholder_enter_bio: 'Scrivi qualcosa su di te',
  placeholder_bio_empty: 'Di\' qualcosa su di te',
  bio: 'Bio',
  delete_account: 'Elimina account',
  delete_warning: 'Questa azione non può essere annullata.',
  delete_data_intro: 'I seguenti dati verranno eliminati definitivamente:',
  delete_item_profile: 'Le informazioni del tuo profilo',
  delete_item_chat: 'Cronologia chat e sessioni',
  delete_item_contact: 'Informazioni sui contatti',
  delete_item_all: 'Tutti i dati associati',
  final_confirmation: 'Conferma finale',
  delete_confirm_prompt: 'Digita "delete" per confermare:',
  placeholder_type_delete: 'Digita delete',
  private_token: 'Token privato',
  token_desc: 'Genera un token per l\'accesso API',
  toast_not_logged_in: 'Utente non connesso',
  toast_name_required: 'Il nome è obbligatorio',
  toast_save_success: 'Salvato con successo',
  toast_save_failed: 'Salvataggio non riuscito',
  toast_image_too_large: 'L\'immagine supera il limite di 5MB',
  toast_avatar_updated: 'Avatar aggiornato',
  toast_avatar_failed: 'Aggiornamento dell\'avatar non riuscito',
  toast_upload_failed: 'Caricamento non riuscito',
  toast_token_generated: 'Token generato',
  toast_token_failed: 'Generazione del token non riuscita',
  toast_copied: 'Copiato negli appunti',
  toast_copy_failed: 'Copia non riuscita',
  toast_account_deleted: 'Account eliminato con successo',
  toast_delete_account_failed: 'Eliminazione dell\'account non riuscita',
  toast_logout_success: 'Disconnessione riuscita',
  toast_logout_failed: 'Disconnessione non riuscita',
  profile_tab_messages: 'Messaggi',
  profile_tab_comments: 'Commenti',
  profile_tab_likes: 'Mi piace',
  profile_tab_bookmarks: 'Salvati',
  profile_empty_messages: 'Ancora nessun messaggio',
  profile_empty_comments: 'Ancora nessun commento',
  profile_empty_likes: 'Ancora nessun mi piace',
  profile_empty_bookmarks: 'Ancora nessun salvataggio',
  profile_reply_to: 'Rispondi a {name}',
  profile_stats_posts: 'Messaggi',
  profile_stats_comments: 'Commenti',
  profile_stats_likes: 'Mi piace ricevuti',
  profile_joined: 'Iscritto il {date}',

  // ReportDialog.vue
  report_message_title: 'Segnala messaggio',
  report_reason_prompt: 'Seleziona il motivo per segnalare questo messaggio:',
  report_spam: 'Spam',
  report_harassment: 'Molestie o bullismo',
  report_inappropriate: 'Contenuto inappropriato',
  report_other: 'Altro',
  placeholder_report_desc: 'Descrivi il problema (opzionale)',
  toast_select_reason: 'Seleziona un motivo',
  toast_report_success: 'Segnalazione inviata con successo',
  toast_report_failed: 'Invio della segnalazione non riuscito',

  // common.js
  ellipsis: '..',

  // ChatBox.vue / ChatMsgList.vue message summary prefixes
  summary_image: '[Immagine]',
  summary_images: '[Immagini x{count}]',
  summary_file: '[File]',
  summary_files: '[File x{count}]',
  summary_video: '[Video]',
  summary_videos: '[Video x{count}]',
  summary_location: '[Posizione]',
  summary_locations: '[Posizioni x{count}]',
  summary_emoji: '[Emoji]',
  summary_emojis: '[Emoji x{count}]',
  summary_voice: '[Voce]',
  summary_voices: '[Voci x{count}]',
  summary_mixed: '[Misto]',
  summary_other: '[Altro]',

  // Voice messages
  voice: 'Voce',
  voice_recording: 'Registrazione...',
  toast_voice_too_short: 'Registrazione troppo breve',
  toast_voice_failed: 'Invio della voce non riuscito',
  toast_mic_permission_denied: 'Impossibile accedere al microfono. Abilitalo nelle impostazioni del browser',
  toast_recording_not_supported: 'La registrazione vocale non è supportata in questo browser',
  voice_load_failed: 'Caricamento del messaggio vocale non riuscito',

  // Expire At
  aiChat_expireLine: 'Valido fino a {date}, avvisa AI quando vuoi per aggiornarlo',
  aiChat_expireExpired: 'Il contenuto è scaduto e non è più visibile agli altri. Avvisa AI quando vuoi per aggiornare la scadenza',

  // MatchedSession.vue
  detail: 'Dettaglio',

  // Match notification hints
  match_new_result_hint: 'Se ci saranno nuovi risultati di match, riceverai una notifica. Per una migliore esperienza, installa l\'app e ricevi notifiche all\'istante.',

  // Match notification hints
  match_connection_notify_hint: 'Match fatto e notificato! Vai a salutare!',
  match_continuousMatching: 'AI continua ad abbinarti',
  match_continuousMatchingHint: 'Ti faremo sapere appena troviamo nuovi match',
  match_continuousMatchingOthers: 'AI continua ad abbinare per loro',
  match_continuousMatchingOthersHint: 'I nuovi match appariranno qui man mano che si trovano',
  match_noResultsTitleOthers: 'Sto ancora cercando un match per loro',
  match_noResultsHintOthers: 'AI continua ad abbinare per loro. I risultati appariranno qui una volta trovati.',
  match_newMatchFound: '{n} nuovi match trovati!',
  match_worth_exploring_hint: 'Decidi tu se contattare.',

  // Matches filter tags
  filter_all: 'Tutti',
  filter_best_connection: 'Match migliore',
  filter_worth_a_look: 'Da vedere',

  // LandingPage.vue (CN Portal)
  landing_brand_slogan: 'OctoSay - L\'IA che ti capisce e ti abbina alla persona giusta',
  landing_hero_title: 'Scrivi nel tuo gruppo — AI chiarisce prima, poi pubblichi e ottieni match.',
  landing_hero_subtitle: 'Scrivi il messaggio che vuoi condividere in un Gruppo Octo. Prima che vada online, AI chiacchiererà con te per definire i dettagli. Quando confermi, il tuo messaggio e il riassunto dell\'IA vengono pubblicati insieme, e AI inizia ad abbinarti.',
  landing_download_on: 'Scarica su',
  landing_get_it_on: 'Disponibile su',
  landing_direct_download: 'Download diretto',
  landing_how_title: 'Come funziona',
  landing_step1_title: 'Scrivi nell\'Gruppo',
  landing_step1_desc: 'Scrivi il messaggio che vuoi condividere nell\'gruppo. L\'IA prima chiacchiererà con te per chiarire i dettagli, così ogni post è chiaro, utile e pronto per l\'abbinamento — non si perde nel rumore.',
  landing_step2_title: 'Conferma, pubblica e ottieni match',
  landing_step2_desc: 'Quando confermi, il tuo messaggio originale e il riassunto dell\'IA vengono pubblicati insieme nell\'gruppo. Poi l\'IA continua a cercare i tuoi match migliori, così il tuo messaggio non resta sepolto o ignorato.',
  landing_step3_title: 'Connettiti e chiacchiera',
  landing_step3_desc: 'Quando c\'è un match, entrambi possono vedere la cronologia chat di ciascuno con AI e il riassunto dell\'IA. Con un contesto condiviso, rompere il ghiaccio è facile — basta chiacchierare in modo naturale.',
  // Comparison Section
  landing_comparison_title: 'Perché OctoSay?',
  landing_comparison_subtitle: 'Chat da gruppo, ma AI chiarisce i tuoi dettagli e ti abbina attivamente.',
  landing_comparison_other: 'Discord',
  landing_comparison_octo: 'OctoSay',
  landing_cmp1_label: 'Qualità dei contenuti',
  landing_cmp1_other: 'Spam, pubblicità e messaggi fuori tema in quantità',
  landing_cmp1_octo: 'Solo schede di esigenze selezionate dall\'IA',
  landing_cmp2_label: 'Trovare persone',
  landing_cmp2_other: 'Pubblichi e aspetti solo le risposte',
  landing_cmp2_octo: 'AI ti abbina attivamente',
  landing_cmp3_label: 'Livello di rumore',
  landing_cmp3_other: 'Centinaia di messaggi da sfogliare',
  landing_cmp3_octo: 'Rumore zero, ogni post conta',
  landing_cmp4_label: 'Per iniziare',
  landing_cmp4_other: 'Cerca il server, sfoglia i canali, impara da solo',
  landing_cmp4_octo: 'Scrivi nell\'gruppo; AI chiarisce e abbina',
  landing_cmp_other_wechat: 'WeChat',
  landing_cmp_other_xhs: 'Xiaohongshu',
  landing_cmp_other_facebook: 'Facebook',
  landing_cmp_other_reddit: 'Reddit',
  landing_cmp1_wechat: 'Chat di gruppo invase da pubblicità e spam',
  landing_cmp1_xhs: 'Post promozionali ovunque, difficile fidarsi',
  landing_cmp1_facebook: 'Pubblicità e clickbait inondano il feed',
  landing_cmp1_reddit: 'Spam e post fuori tema ovunque',
  landing_cmp2_wechat: 'Solo tramite contatti e inviti ai gruppi',
  landing_cmp2_xhs: 'Cerca da solo e setaccia i post',
  landing_cmp2_facebook: 'Limitato ai tuoi amici e gruppi esistenti',
  landing_cmp2_reddit: 'Sfoglia i subreddit da solo e spera nelle risposte',
  landing_cmp3_wechat: 'Centinaia di messaggi di gruppo da sfogliare',
  landing_cmp3_xhs: 'Feed pieno di consigli e pubblicità',
  landing_cmp3_facebook: 'Post consigliati e pubblicità senza fine',
  landing_cmp3_reddit: 'Centinaia di commenti da sfogliare',
  landing_cmp5_label: 'Chi fa la ricerca',
  landing_cmp5_wechat: 'Chiedi a uno alla volta, sperando nella fortuna',
  landing_cmp5_xhs: 'Pubblica, aspetta i commenti, filtra da solo',
  landing_cmp5_facebook: 'Devi chiedere in giro per i gruppi',
  landing_cmp5_reddit: 'Pubblica, aspetta le risposte, poi filtra',
  landing_cmp5_octo: 'L\'IA continua a trovarti persone, automaticamente',

  landing_features_title: 'Funzioni principali',
  landing_feature1_title: 'Chiarisci prima di pubblicare',
  landing_feature1_desc: 'Nessun modulo da compilare. Scrivi il tuo messaggio nell\'gruppo e AI chiacchiererà prima con te per fare le domande giuste e capire davvero le tue esigenze.',
  landing_feature2_title: 'Pulito, non caotico',
  landing_feature2_desc: 'Il tuo messaggio e il riassunto dell\'IA vengono pubblicati insieme — OctoSay cura ogni post, quindi niente spam, niente flood fuori tema, niente rumore da sfogliare.',
  landing_feature3_title: 'Abbinamento proattivo',
  landing_feature3_desc: 'Una volta che confermi e il tuo messaggio + riassunto IA sono online, AI scandisce continuamente l\'gruppo per trovare persone adatte a quello che cerchi — e spiega perché.',
  landing_feature4_title: 'Comunità per argomento, rumore zero',
  landing_feature4_desc: 'Unisciti a gruppo per argomento — sport, gaming, scambio linguistico, coinquilini — AI chiarisce il tuo messaggio prima di pubblicarlo, così ogni gruppo resta pulito e utile.',
  landing_feature5_title: 'Privacy protetta',
  landing_feature5_desc: 'Puoi rendere privati i messaggi dopo l\'invio, visibili solo a te. Controllo totale.',
  landing_feature6_title: 'Conversazioni significative',
  landing_feature6_desc: 'Niente rumore, niente distrazioni — ogni messaggio conta.',
  landing_usecases_title: 'Funziona per qualsiasi scenario',
  landing_usecases_subtitle: 'Qualunque cosa tu abbia in mente, unisciti a un gruppo per argomento — AI si occupa dell\'abbinamento così non devi sfogliare e cercare',
  landing_usecase_game: 'Compagno di gioco',
  landing_usecase_language: 'Scambio linguistico',
  landing_usecase_skill: 'Scambio di competenze',
  landing_usecase_roommate: 'Trova coinquilino',
  landing_usecase_travel: 'Compagno di viaggio',
  landing_usecase_sports: 'Partner sportivo',
  landing_usecase_study: 'Partner di studio',
  landing_usecase_anything: '...o condividi qualsiasi cosa',
  landing_cta_title: 'Pronto a iniziare?',
  landing_cta_desc: 'Unisciti a un gruppo per argomento, scrivi cosa vuoi condividere, lascia che AI chiarisca i dettagli, poi pubblica e fai match con le persone giuste.',
  landing_use_now: 'Usa ora',
  landing_groups: 'Gruppo',

  // OnboardingPage.vue
  onboarding_skip: 'Salta',
  onboarding_next: 'Avanti',
  onboarding_getStarted: 'Inizia',
  onboarding_step1Title: "Dì cosa vuoi nel Gruppo",
  onboarding_step1Desc: "Che tu stia cercando qualcosa o voglia fare qualcosa, dillo semplicemente. L'IA chiacchiera con te per chiarire i dettagli e lo trasforma in un'esigenza chiara.",
  onboarding_step2Title: 'Conferma, pubblica e ottieni match',
  onboarding_step2Desc: "Una volta pubblicato il tuo messaggio nell'gruppo, l'IA continua a cercare i tuoi match migliori, così il tuo messaggio non resta sepolto o ignorato.",
  onboarding_step3Title: 'Connettiti e chiacchiera',
  onboarding_step3Desc: "Entrambi possono vedere la conversazione dell'altro con l'IA e sapere cosa cerca. Con un contesto condiviso, rompere il ghiaccio è facile — basta chiacchierare in modo naturale.",

  // ChannelDetail.vue
  channel_image_limit: 'Massimo 1 immagine',

  // ChannelMembers.vue
  channel_members_empty: 'Ancora nessun membro',
  channel_members_title: 'Membri',
  channel_role_owner: 'Proprietario',
  channel_role_admin: 'Amministratore',
  channel_role_member: 'Membro',

  // Settings.vue
  settings_language: 'Lingua',
  settings_language_followSystem: 'Come da sistema',

  // ChatBox.vue
  match_interested_suffix: ', {count} da vedere',

  // ChatBox.vue - Fasi del progresso di abbinamento AI
  match_stage_fetch_chat: 'Recupero della conversazione',
  match_stage_query_expansion: 'Espansione delle query',
  match_stage_semantic_search: 'Ricerca semantica',
  match_stage_deep_search: 'Analisi approfondita',
  match_stage_rerank: 'Abbinamento intelligente',
  match_stage_refining: 'Ottimizzazione dei risultati',
  match_stage_fetch_details: 'Recupero dei dettagli',

  // ChannelDetail.vue - Caricamento immagini
  channel_select_image: 'Seleziona un file immagine',
  channel_image_upload_failed: 'Caricamento dell\'immagine non riuscito, riprova',
  chatInput_channelSearchHint: "Cerca gruppi",
}



// WEBPACK FOOTER //
// ./src/i18n/it.js